import { createContext, useContext } from 'react';

// The permissions of the logged-in staff account (J/authority/Permission), as GET /api/me answers
// them: AdminRoute provides the answer it decided on, so every admin screen below it can ask
// `useCan()('people.merge')` before it offers an action. The backend enforces every permission
// itself; hiding an action only spares a team member a refusal.
//
// Outside an AdminRoute (a test that renders one screen on its own) the context is null and nothing
// is hidden.
export const PermissionsContext = createContext(null);

export const PERMISSIONS = {
  staffManage: 'staff.manage',
  peopleDelete: 'people.delete',
  peopleMerge: 'people.merge',
  peopleExport: 'people.export',
  eventsCreateDelete: 'events.createDelete',
  programImportApply: 'program.importApply',
  legalNoticeEdit: 'legalNotice.edit',
};

export const useCan = () => {
  const permissions = useContext(PermissionsContext);
  return (key) => permissions === null || permissions.includes(key);
};
